import {IRankingItem} from "../types/IRankingItem";

const bialystokRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 9692,
        offerId: 18275
    },
    {
        regionOrder: 2,
        regionId: 9692,
        offerId: 19179
    },
    {
        regionOrder: 3,
        regionId: 9692,
        offerId: 12602
    },
    {
        regionOrder: 4,
        regionId: 9692,
        offerId: 16568
    },
    {
        regionOrder: 5,
        regionId: 9692,
        offerId: 19913
    }
];
const bydgoszczRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 22550,
        offerId: 11325
    },
    {
        regionOrder: 2,
        regionId: 22550,
        offerId: 17266
    },
    {
        regionOrder: 3,
        regionId: 22550,
        offerId: 18678
    },
    {
        regionOrder: 4,
        regionId: 22550,
        offerId: 14545
    },
    {
        regionOrder: 5,
        regionId: 22550,
        offerId: 13911
    },
    {
        regionOrder: 6,
        regionId: 22550,
        offerId: 16546
    },
    {
        regionOrder: 7,
        regionId: 22550,
        offerId: 12148
    },
    {
        regionOrder: 8,
        regionId: 22550,
        offerId: 16629
    },
    {
        regionOrder: 9,
        regionId: 22550,
        offerId: 19447
    },
    {
        regionOrder: 10,
        regionId: 22550,
        offerId: 16465
    }
];
const gdanskRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 46083,
        offerId: 15119
    },
    {
        regionOrder: 2,
        regionId: 46083,
        offerId: 14738
    },
    {
        regionOrder: 3,
        regionId: 46083,
        offerId: 18047
    },
    {
        regionOrder: 4,
        regionId: 46083,
        offerId: 16528
    },
    {
        regionOrder: 5,
        regionId: 46083,
        offerId: 18267
    },
    {
        regionOrder: 6,
        regionId: 46083,
        offerId: 19629
    },
    {
        regionOrder: 7,
        regionId: 46083,
        offerId: 17603
    },
    {
        regionOrder: 8,
        regionId: 46083,
        offerId: 17824
    },
    {
        regionOrder: 9,
        regionId: 46083,
        offerId: 18344
    },
    {
        regionOrder: 10,
        regionId: 46083,
        offerId: 19020
    }
];
const gdyniaRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 6196,
        offerId: 17758
    },
    {
        regionOrder: 2,
        regionId: 6196,
        offerId: 18409
    },
    {
        regionOrder: 3,
        regionId: 6196,
        offerId: 17971
    },
    {
        regionOrder: 4,
        regionId: 6196,
        offerId: 17678
    },
    {
        regionOrder: 5,
        regionId: 6196,
        offerId: 18778
    },
    {
        regionOrder: 6,
        regionId: 6196,
        offerId: 19396
    },
    {
        regionOrder: 7,
        regionId: 6196,
        offerId: 16889
    },
    {
        regionOrder: 8,
        regionId: 6196,
        offerId: 15816
    },
    {
        regionOrder: 9,
        regionId: 6196,
        offerId: 10409
    },
    {
        regionOrder: 10,
        regionId: 6196,
        offerId: 17931
    }
];
const katowiceRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 31600,
        offerId: 10869
    },
    {
        regionOrder: 2,
        regionId: 31600,
        offerId: 15173
    },
    {
        regionOrder: 3,
        regionId: 31600,
        offerId: 18025
    },
    {
        regionOrder: 4,
        regionId: 31600,
        offerId: 17121
    },
    {
        regionOrder: 5,
        regionId: 31600,
        offerId: 19111
    },
    {
        regionOrder: 6,
        regionId: 31600,
        offerId: 19453
    },
    {
        regionOrder: 7,
        regionId: 31600,
        offerId: 18026
    },
    {
        regionOrder: 8,
        regionId: 31600,
        offerId: 16715
    },
    {
        regionOrder: 9,
        regionId: 31600,
        offerId: 17429
    },
    {
        regionOrder: 10,
        regionId: 31600,
        offerId: 18591
    }
];
const kielceRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 36190,
        offerId: 17397
    },
    {
        regionOrder: 2,
        regionId: 36190,
        offerId: 17699
    },
    {
        regionOrder: 3,
        regionId: 36190,
        offerId: 19308
    },
    {
        regionOrder: 4,
        regionId: 36190,
        offerId: 17710
    },
    {
        regionOrder: 5,
        regionId: 36190,
        offerId: 17700
    },
    {
        regionOrder: 6,
        regionId: 36190,
        offerId: 19309
    },
    {
        regionOrder: 7,
        regionId: 36190,
        offerId: 19604
    },
    {
        regionOrder: 8,
        regionId: 36190,
        offerId: 19656
    },
    {
        regionOrder: 9,
        regionId: 36190,
        offerId: 17701
    },
    {
        regionOrder: 10,
        regionId: 36190,
        offerId: 19906
    }
];
const krakowRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 11158,
        offerId: 16983
    },
    {
        regionOrder: 2,
        regionId: 11158,
        offerId: 16906
    },
    {
        regionOrder: 3,
        regionId: 11158,
        offerId: 15082
    },
    {
        regionOrder: 4,
        regionId: 11158,
        offerId: 15916
    },
    {
        regionOrder: 5,
        regionId: 11158,
        offerId: 18141
    },
    {
        regionOrder: 6,
        regionId: 11158,
        offerId: 19106
    },
    {
        regionOrder: 7,
        regionId: 11158,
        offerId: 19540
    },
    {
        regionOrder: 8,
        regionId: 11158,
        offerId: 17289
    },
    {
        regionOrder: 9,
        regionId: 11158,
        offerId: 16147
    },
    {
        regionOrder: 10,
        regionId: 11158,
        offerId: 18385
    }
];
const lodzRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 16187,
        offerId: 17617
    },
    {
        regionOrder: 2,
        regionId: 16187,
        offerId: 16478
    },
    {
        regionOrder: 3,
        regionId: 16187,
        offerId: 18494
    },
    {
        regionOrder: 4,
        regionId: 16187,
        offerId: 16262
    },
    {
        regionOrder: 5,
        regionId: 16187,
        offerId: 18818
    },
    {
        regionOrder: 6,
        regionId: 16187,
        offerId: 17334
    },
    {
        regionOrder: 7,
        regionId: 16187,
        offerId: 19035
    },
    {
        regionOrder: 8,
        regionId: 16187,
        offerId: 16079
    },
    {
        regionOrder: 9,
        regionId: 16187,
        offerId: 15885
    },
    {
        regionOrder: 10,
        regionId: 16187,
        offerId: 16316
    }
];
const lublinRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 13220,
        offerId: 16330
    },
    {
        regionOrder: 2,
        regionId: 13220,
        offerId: 14467
    },
    {
        regionOrder: 3,
        regionId: 13220,
        offerId: 17852
    },
    {
        regionOrder: 4,
        regionId: 13220,
        offerId: 13823
    },
    {
        regionOrder: 5,
        regionId: 13220,
        offerId: 19376
    },
    {
        regionOrder: 6,
        regionId: 13220,
        offerId: 18330
    },
    {
        regionOrder: 7,
        regionId: 13220,
        offerId: 16963
    },
    {
        regionOrder: 8,
        regionId: 13220,
        offerId: 16240
    },
    {
        regionOrder: 9,
        regionId: 13220,
        offerId: 17409
    },
    {
        regionOrder: 10,
        regionId: 13220,
        offerId: 16180
    }
];
const olsztynRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 26804,
        offerId: 17153
    },
    {
        regionOrder: 2,
        regionId: 26804,
        offerId: 18296
    },
    {
        regionOrder: 3,
        regionId: 26804,
        offerId: 16878
    },
    {
        regionOrder: 4,
        regionId: 26804,
        offerId: 16934
    },
    {
        regionOrder: 5,
        regionId: 26804,
        offerId: 19568
    },
    {
        regionOrder: 6,
        regionId: 26804,
        offerId: 19090
    },
    {
        regionOrder: 7,
        regionId: 26804,
        offerId: 15167
    }
];
const poznanRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 30892,
        offerId: 16668
    },
    {
        regionOrder: 2,
        regionId: 30892,
        offerId: 19521
    },
    {
        regionOrder: 3,
        regionId: 30892,
        offerId: 18497
    },
    {
        regionOrder: 4,
        regionId: 30892,
        offerId: 18105
    },
    {
        regionOrder: 5,
        regionId: 30892,
        offerId: 14726
    },
    {
        regionOrder: 6,
        regionId: 30892,
        offerId: 18888
    },
    {
        regionOrder: 7,
        regionId: 30892,
        offerId: 15726
    },
    {
        regionOrder: 8,
        regionId: 30892,
        offerId: 19010
    },
    {
        regionOrder: 9,
        regionId: 30892,
        offerId: 17540
    },
    {
        regionOrder: 10,
        regionId: 30892,
        offerId: 17247
    }
];
const rzeszowRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 33659,
        offerId: 16854
    },
    {
        regionOrder: 2,
        regionId: 33659,
        offerId: 17564
    },
    {
        regionOrder: 3,
        regionId: 33659,
        offerId: 17216
    },
    {
        regionOrder: 4,
        regionId: 33659,
        offerId: 19223
    },
    {
        regionOrder: 5,
        regionId: 33659,
        offerId: 18384
    },
    {
        regionOrder: 6,
        regionId: 33659,
        offerId: 13572
    },
    {
        regionOrder: 7,
        regionId: 33659,
        offerId: 16471
    },
    {
        regionOrder: 8,
        regionId: 33659,
        offerId: 13568
    },
    {
        regionOrder: 9,
        regionId: 33659,
        offerId: 18994
    },
    {
        regionOrder: 10,
        regionId: 33659,
        offerId: 17268
    }
];
const szczecinRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 32657,
        offerId: 16826
    },
    {
        regionOrder: 2,
        regionId: 32657,
        offerId: 17093
    },
    {
        regionOrder: 3,
        regionId: 32657,
        offerId: 13786
    },
    {
        regionOrder: 4,
        regionId: 32657,
        offerId: 16758
    },
    {
        regionOrder: 5,
        regionId: 32657,
        offerId: 19105
    },
    {
        regionOrder: 6,
        regionId: 32657,
        offerId: 17588
    },
    {
        regionOrder: 7,
        regionId: 32657,
        offerId: 17450
    },
    {
        regionOrder: 8,
        regionId: 32657,
        offerId: 18477
    },
    {
        regionOrder: 9,
        regionId: 32657,
        offerId: 13655
    },
    {
        regionOrder: 10,
        regionId: 32657,
        offerId: 19006
    }
];
const torunRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 19894,
        offerId: 18724
    },
    {
        regionOrder: 2,
        regionId: 19894,
        offerId: 17331
    },
    {
        regionOrder: 3,
        regionId: 19894,
        offerId: 17336
    },
    {
        regionOrder: 4,
        regionId: 19894,
        offerId: 17269
    },
    {
        regionOrder: 5,
        regionId: 19894,
        offerId: 16409
    },
    {
        regionOrder: 6,
        regionId: 19894,
        offerId: 16569
    },
    {
        regionOrder: 7,
        regionId: 19894,
        offerId: 18498
    },
    {
        regionOrder: 8,
        regionId: 19894,
        offerId: 15725
    },
    {
        regionOrder: 9,
        regionId: 19894,
        offerId: 18721
    },
    {
        regionOrder: 10,
        regionId: 19894,
        offerId: 16764
    }
];
const warszawaRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 8647,
        offerId: 16394
    },
    {
        regionOrder: 2,
        regionId: 8647,
        offerId: 13935
    },
    {
        regionOrder: 3,
        regionId: 8647,
        offerId: 19227
    },
    {
        regionOrder: 4,
        regionId: 8647,
        offerId: 16798
    },
    {
        regionOrder: 5,
        regionId: 8647,
        offerId: 19038
    },
    {
        regionOrder: 6,
        regionId: 8647,
        offerId: 17562
    },
    {
        regionOrder: 7,
        regionId: 8647,
        offerId: 18935
    },
    {
        regionOrder: 8,
        regionId: 8647,
        offerId: 17092
    },
    {
        regionOrder: 9,
        regionId: 8647,
        offerId: 18907
    },
    {
        regionOrder: 10,
        regionId: 8647,
        offerId: 18150
    }
];
const wroclawRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 26955,
        offerId: 17170
    },
    {
        regionOrder: 2,
        regionId: 26955,
        offerId: 14657
    },
    {
        regionOrder: 3,
        regionId: 26955,
        offerId: 17123
    },
    {
        regionOrder: 4,
        regionId: 26955,
        offerId: 16784
    },
    {
        regionOrder: 5,
        regionId: 26955,
        offerId: 18480
    },
    {
        regionOrder: 6,
        regionId: 26955,
        offerId: 16695
    },
    {
        regionOrder: 7,
        regionId: 26955,
        offerId: 18036
    },
    {
        regionOrder: 8,
        regionId: 26955,
        offerId: 15982
    },
    {
        regionOrder: 9,
        regionId: 26955,
        offerId: 14783
    },
    {
        regionOrder: 10,
        regionId: 26955,
        offerId: 17537
    }
];

export const ranking2025: IRankingItem[] = [
    ...bialystokRanking,
    ...bydgoszczRanking,
    ...gdanskRanking,
    ...gdyniaRanking,
    ...katowiceRanking,
    ...kielceRanking,
    ...krakowRanking,
    ...lublinRanking,
    ...lodzRanking,
    ...olsztynRanking,
    ...poznanRanking,
    ...rzeszowRanking,
    ...szczecinRanking,
    ...torunRanking,
    ...warszawaRanking,
    ...wroclawRanking
];
import {IRankingItem} from "../types/IRankingItem";

const bialystokRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 9692,
        offerId: 18275
    },
    {
        regionOrder: 2,
        regionId: 9692,
        offerId: 19179
    },
    {
        regionOrder: 3,
        regionId: 9692,
        offerId: 12602
    },
    {
        regionOrder: 4,
        regionId: 9692,
        offerId: 16568
    },
    {
        regionOrder: 5,
        regionId: 9692,
        offerId: 19913
    }
];
const bydgoszczRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 22550,
        offerId: 11325
    },
    {
        regionOrder: 2,
        regionId: 22550,
        offerId: 17266
    },
    {
        regionOrder: 3,
        regionId: 22550,
        offerId: 18678
    },
    {
        regionOrder: 4,
        regionId: 22550,
        offerId: 14545
    },
    {
        regionOrder: 5,
        regionId: 22550,
        offerId: 13911
    },
    {
        regionOrder: 6,
        regionId: 22550,
        offerId: 16546
    },
    {
        regionOrder: 7,
        regionId: 22550,
        offerId: 12148
    },
    {
        regionOrder: 8,
        regionId: 22550,
        offerId: 16629
    },
    {
        regionOrder: 9,
        regionId: 22550,
        offerId: 19447
    },
    {
        regionOrder: 10,
        regionId: 22550,
        offerId: 16465
    }
];
const gdanskRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 46083,
        offerId: 15119
    },
    {
        regionOrder: 2,
        regionId: 46083,
        offerId: 14738
    },
    {
        regionOrder: 3,
        regionId: 46083,
        offerId: 18047
    },
    {
        regionOrder: 4,
        regionId: 46083,
        offerId: 16528
    },
    {
        regionOrder: 5,
        regionId: 46083,
        offerId: 18267
    },
    {
        regionOrder: 6,
        regionId: 46083,
        offerId: 19629
    },
    {
        regionOrder: 7,
        regionId: 46083,
        offerId: 17603
    },
    {
        regionOrder: 8,
        regionId: 46083,
        offerId: 17824
    },
    {
        regionOrder: 9,
        regionId: 46083,
        offerId: 18344
    },
    {
        regionOrder: 10,
        regionId: 46083,
        offerId: 19020
    }
];
const gdyniaRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 6196,
        offerId: 17758
    },
    {
        regionOrder: 2,
        regionId: 6196,
        offerId: 18409
    },
    {
        regionOrder: 3,
        regionId: 6196,
        offerId: 17971
    },
    {
        regionOrder: 4,
        regionId: 6196,
        offerId: 17678
    },
    {
        regionOrder: 5,
        regionId: 6196,
        offerId: 18778
    },
    {
        regionOrder: 6,
        regionId: 6196,
        offerId: 19396
    },
    {
        regionOrder: 7,
        regionId: 6196,
        offerId: 16889
    },
    {
        regionOrder: 8,
        regionId: 6196,
        offerId: 15816
    },
    {
        regionOrder: 9,
        regionId: 6196,
        offerId: 10409
    },
    {
        regionOrder: 10,
        regionId: 6196,
        offerId: 17931
    }
];
const katowiceRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 31600,
        offerId: 10869
    },
    {
        regionOrder: 2,
        regionId: 31600,
        offerId: 15173
    },
    {
        regionOrder: 3,
        regionId: 31600,
        offerId: 18025
    },
    {
        regionOrder: 4,
        regionId: 31600,
        offerId: 17121
    },
    {
        regionOrder: 5,
        regionId: 31600,
        offerId: 19111
    },
    {
        regionOrder: 6,
        regionId: 31600,
        offerId: 19453
    },
    {
        regionOrder: 7,
        regionId: 31600,
        offerId: 18026
    },
    {
        regionOrder: 8,
        regionId: 31600,
        offerId: 16715
    },
    {
        regionOrder: 9,
        regionId: 31600,
        offerId: 17429
    },
    {
        regionOrder: 10,
        regionId: 31600,
        offerId: 18591
    }
];
const kielceRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 36190,
        offerId: 17397
    },
    {
        regionOrder: 2,
        regionId: 36190,
        offerId: 17699
    },
    {
        regionOrder: 3,
        regionId: 36190,
        offerId: 19308
    },
    {
        regionOrder: 4,
        regionId: 36190,
        offerId: 17710
    },
    {
        regionOrder: 5,
        regionId: 36190,
        offerId: 17700
    },
    {
        regionOrder: 6,
        regionId: 36190,
        offerId: 19309
    },
    {
        regionOrder: 7,
        regionId: 36190,
        offerId: 19604
    },
    {
        regionOrder: 8,
        regionId: 36190,
        offerId: 19656
    },
    {
        regionOrder: 9,
        regionId: 36190,
        offerId: 17701
    },
    {
        regionOrder: 10,
        regionId: 36190,
        offerId: 19906
    }
];
const krakowRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 11158,
        offerId: 16983
    },
    {
        regionOrder: 2,
        regionId: 11158,
        offerId: 16906
    },
    {
        regionOrder: 3,
        regionId: 11158,
        offerId: 15082
    },
    {
        regionOrder: 4,
        regionId: 11158,
        offerId: 15916
    },
    {
        regionOrder: 5,
        regionId: 11158,
        offerId: 18141
    },
    {
        regionOrder: 6,
        regionId: 11158,
        offerId: 19106
    },
    {
        regionOrder: 7,
        regionId: 11158,
        offerId: 19540
    },
    {
        regionOrder: 8,
        regionId: 11158,
        offerId: 17289
    },
    {
        regionOrder: 9,
        regionId: 11158,
        offerId: 16147
    },
    {
        regionOrder: 10,
        regionId: 11158,
        offerId: 18385
    }
];
const lodzRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 16187,
        offerId: 17617
    },
    {
        regionOrder: 2,
        regionId: 16187,
        offerId: 16478
    },
    {
        regionOrder: 3,
        regionId: 16187,
        offerId: 18494
    },
    {
        regionOrder: 4,
        regionId: 16187,
        offerId: 16262
    },
    {
        regionOrder: 5,
        regionId: 16187,
        offerId: 18818
    },
    {
        regionOrder: 6,
        regionId: 16187,
        offerId: 17334
    },
    {
        regionOrder: 7,
        regionId: 16187,
        offerId: 19035
    },
    {
        regionOrder: 8,
        regionId: 16187,
        offerId: 16079
    },
    {
        regionOrder: 9,
        regionId: 16187,
        offerId: 15885
    },
    {
        regionOrder: 10,
        regionId: 16187,
        offerId: 16316
    }
];
const lublinRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 13220,
        offerId: 16330
    },
    {
        regionOrder: 2,
        regionId: 13220,
        offerId: 14467
    },
    {
        regionOrder: 3,
        regionId: 13220,
        offerId: 17852
    },
    {
        regionOrder: 4,
        regionId: 13220,
        offerId: 13823
    },
    {
        regionOrder: 5,
        regionId: 13220,
        offerId: 19376
    },
    {
        regionOrder: 6,
        regionId: 13220,
        offerId: 18330
    },
    {
        regionOrder: 7,
        regionId: 13220,
        offerId: 16963
    },
    {
        regionOrder: 8,
        regionId: 13220,
        offerId: 16240
    },
    {
        regionOrder: 9,
        regionId: 13220,
        offerId: 17409
    },
    {
        regionOrder: 10,
        regionId: 13220,
        offerId: 16180
    }
];
const olsztynRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 26804,
        offerId: 17153
    },
    {
        regionOrder: 2,
        regionId: 26804,
        offerId: 18296
    },
    {
        regionOrder: 3,
        regionId: 26804,
        offerId: 16878
    },
    {
        regionOrder: 4,
        regionId: 26804,
        offerId: 16934
    },
    {
        regionOrder: 5,
        regionId: 26804,
        offerId: 19568
    },
    {
        regionOrder: 6,
        regionId: 26804,
        offerId: 19090
    },
    {
        regionOrder: 7,
        regionId: 26804,
        offerId: 15167
    }
];
const poznanRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 30892,
        offerId: 16668
    },
    {
        regionOrder: 2,
        regionId: 30892,
        offerId: 19521
    },
    {
        regionOrder: 3,
        regionId: 30892,
        offerId: 18497
    },
    {
        regionOrder: 4,
        regionId: 30892,
        offerId: 18105
    },
    {
        regionOrder: 5,
        regionId: 30892,
        offerId: 14726
    },
    {
        regionOrder: 6,
        regionId: 30892,
        offerId: 18888
    },
    {
        regionOrder: 7,
        regionId: 30892,
        offerId: 15726
    },
    {
        regionOrder: 8,
        regionId: 30892,
        offerId: 19010
    },
    {
        regionOrder: 9,
        regionId: 30892,
        offerId: 17540
    },
    {
        regionOrder: 10,
        regionId: 30892,
        offerId: 17247
    }
];
const rzeszowRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 33659,
        offerId: 16854
    },
    {
        regionOrder: 2,
        regionId: 33659,
        offerId: 17564
    },
    {
        regionOrder: 3,
        regionId: 33659,
        offerId: 17216
    },
    {
        regionOrder: 4,
        regionId: 33659,
        offerId: 19223
    },
    {
        regionOrder: 5,
        regionId: 33659,
        offerId: 18384
    },
    {
        regionOrder: 6,
        regionId: 33659,
        offerId: 13572
    },
    {
        regionOrder: 7,
        regionId: 33659,
        offerId: 16471
    },
    {
        regionOrder: 8,
        regionId: 33659,
        offerId: 13568
    },
    {
        regionOrder: 9,
        regionId: 33659,
        offerId: 18994
    },
    {
        regionOrder: 10,
        regionId: 33659,
        offerId: 17268
    }
];
const szczecinRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 32657,
        offerId: 16826
    },
    {
        regionOrder: 2,
        regionId: 32657,
        offerId: 17093
    },
    {
        regionOrder: 3,
        regionId: 32657,
        offerId: 13786
    },
    {
        regionOrder: 4,
        regionId: 32657,
        offerId: 16758
    },
    {
        regionOrder: 5,
        regionId: 32657,
        offerId: 19105
    },
    {
        regionOrder: 6,
        regionId: 32657,
        offerId: 17588
    },
    {
        regionOrder: 7,
        regionId: 32657,
        offerId: 17450
    },
    {
        regionOrder: 8,
        regionId: 32657,
        offerId: 18477
    },
    {
        regionOrder: 9,
        regionId: 32657,
        offerId: 13655
    },
    {
        regionOrder: 10,
        regionId: 32657,
        offerId: 19006
    }
];
const torunRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 19894,
        offerId: 18724
    },
    {
        regionOrder: 2,
        regionId: 19894,
        offerId: 17331
    },
    {
        regionOrder: 3,
        regionId: 19894,
        offerId: 17336
    },
    {
        regionOrder: 4,
        regionId: 19894,
        offerId: 17269
    },
    {
        regionOrder: 5,
        regionId: 19894,
        offerId: 16409
    },
    {
        regionOrder: 6,
        regionId: 19894,
        offerId: 16569
    },
    {
        regionOrder: 7,
        regionId: 19894,
        offerId: 18498
    },
    {
        regionOrder: 8,
        regionId: 19894,
        offerId: 15725
    },
    {
        regionOrder: 9,
        regionId: 19894,
        offerId: 18721
    },
    {
        regionOrder: 10,
        regionId: 19894,
        offerId: 16764
    }
];
const warszawaRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 8647,
        offerId: 16394
    },
    {
        regionOrder: 2,
        regionId: 8647,
        offerId: 13935
    },
    {
        regionOrder: 3,
        regionId: 8647,
        offerId: 19227
    },
    {
        regionOrder: 4,
        regionId: 8647,
        offerId: 16798
    },
    {
        regionOrder: 5,
        regionId: 8647,
        offerId: 19038
    },
    {
        regionOrder: 6,
        regionId: 8647,
        offerId: 17562
    },
    {
        regionOrder: 7,
        regionId: 8647,
        offerId: 18935
    },
    {
        regionOrder: 8,
        regionId: 8647,
        offerId: 17092
    },
    {
        regionOrder: 9,
        regionId: 8647,
        offerId: 18907
    },
    {
        regionOrder: 10,
        regionId: 8647,
        offerId: 18150
    }
];
const wroclawRanking: IRankingItem[] = [
    {
        regionOrder: 1,
        regionId: 26955,
        offerId: 17170
    },
    {
        regionOrder: 2,
        regionId: 26955,
        offerId: 14657
    },
    {
        regionOrder: 3,
        regionId: 26955,
        offerId: 17123
    },
    {
        regionOrder: 4,
        regionId: 26955,
        offerId: 16784
    },
    {
        regionOrder: 5,
        regionId: 26955,
        offerId: 18480
    },
    {
        regionOrder: 6,
        regionId: 26955,
        offerId: 16695
    },
    {
        regionOrder: 7,
        regionId: 26955,
        offerId: 18036
    },
    {
        regionOrder: 8,
        regionId: 26955,
        offerId: 15982
    },
    {
        regionOrder: 9,
        regionId: 26955,
        offerId: 14783
    },
    {
        regionOrder: 10,
        regionId: 26955,
        offerId: 17537
    }
];

export const ranking2025: IRankingItem[] = [
    ...bialystokRanking,
    ...bydgoszczRanking,
    ...gdanskRanking,
    ...gdyniaRanking,
    ...katowiceRanking,
    ...kielceRanking,
    ...krakowRanking,
    ...lublinRanking,
    ...lodzRanking,
    ...olsztynRanking,
    ...poznanRanking,
    ...rzeszowRanking,
    ...szczecinRanking,
    ...torunRanking,
    ...warszawaRanking,
    ...wroclawRanking
];
